import { call, put, select } from 'redux-saga/effects';
import { back, goTo } from '../engine/actions/HistoryActions';
import * as sessionActions from '../engine/actions/SessionActions';
import {
  startOrderSuccess,
  customerDetailsDone,
  deliveryDetailsDone,
  goToCheckout,
  cancelOrder,
} from '../engine/actions/OrderActions';
import { backToOrder } from '../engine/actions/CheckoutActions';
import { FLOW_STEP } from '../engine/reducers/SessionReducer';
import { stateSelector } from 'redux-saga-kit';

function* onGoBack() {
  yield put(back());
}

////////////// helper

export function* goToHelper(state) {
  yield put(goTo({ state }));
}

function stepHandler(step, onlyFrom) {
  return function*(payload) {
    const currentStep = yield select(stateSelector('session.step'));
    if (!onlyFrom || onlyFrom === currentStep) {
      yield call(goToHelper, { step, data: payload });
    }
  };
}

////////////// default export

export default {
  [startOrderSuccess]: { handler: stepHandler(FLOW_STEP.CUSTOMER_DETAILS), noParams: true },
  [customerDetailsDone]: { handler: stepHandler(FLOW_STEP.ADDRESS, FLOW_STEP.CUSTOMER_DETAILS), noParams: true },
  [deliveryDetailsDone]: { handler: stepHandler(FLOW_STEP.ORDER, FLOW_STEP.ADDRESS), noParams: true },
  [sessionActions.goBack]: { handler: onGoBack, noParams: true },
  [goToCheckout]: { handler: stepHandler(FLOW_STEP.CHECKOUT), noParams: true },
  [backToOrder]: { handler: stepHandler(FLOW_STEP.ORDER), noParams: true },
  [cancelOrder]: { handler: stepHandler(FLOW_STEP.IDLE), noParams: true },
};
